import { Component } from '@angular/core';
import { LoaderService } from '../shared/services/loader-service';
import { ChangeDetectorRef, Output, EventEmitter, Inject } from '@angular/core';
import { DataService } from '../shared/services/data.service';
import { CommunicationService } from '../shared/services/communication.service';
import { Router } from '@angular/router';
import { environment } from '../environments/environment';
import { ApiConfigService } from '../shared/services/api-config.service';
import { CommonUtilities } from '../shared/services/utilities';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration, MSAL_INSTANCE } from '@azure/msal-angular';
import { IPublicClientApplication, InteractionStatus, RedirectRequest } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { EventMessage, EventType } from '@azure/msal-browser';
import { filter } from 'rxjs/operators';
import { HttpService } from '../shared/services/http.service';
import { Subscription } from 'rxjs';
import jwt_decode from 'jwt-decode';
import { SHARED_IMPORTS } from '../shared/services/shared-imports';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  standalone: true,
  imports: [...SHARED_IMPORTS]
})
export class AppComponent {
  private readonly _destroying$ = new Subject<void>();
  public showLoader: boolean = false;
  public title = 'Data Quality As A Service';
  public isDropdownOpen: boolean = false; // Add this line
  public isProd = environment.envName;
  public apiEndPoint;
  public globalNavModel: any;
  public globalNavLogin: any;
  public primaryNavModel: any;
  public clientsArr = [];
  public username = '';
  public homeURL = '/home';
  public currentTenantId;
  public countApi = 0;
  public enableMLLinks = ['1', 'BLKc41709e9c2c245c18b0ce2082626d9ad'];
  public enableProfilingLinks = ['1'];
  @Output() onLogin: EventEmitter<any> = new EventEmitter<any>();
  public notAuthorized;
  visibleTextValue = 'Loading...';
  public jermessageModal = {
    content: '',
    visible: false,
    buttonText: 'Close'
  };
  public infoMessage = {
    content: '',
    isInfoNotificationVisible: false,
    buttonText: 'Close'
  };
  public logosConfig = {
    logo: { path: 'assets/optum.svg', alt: 'optum logo' }
  };
  public dtV;
  public showContactDialog;
  public browserDialogModal = {
    show: false,
    closeButton: true
  };
  async initializeMsal() {
    const msalInstance: IPublicClientApplication = this.authService.instance;
    await msalInstance.initialize();
  }
  constructor(private loaderService: LoaderService, private dt: DataService, private cm: CommunicationService, private router: Router, private cdr: ChangeDetectorRef, private cu: CommonUtilities, @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration, private http: HttpService, @Inject(MSAL_INSTANCE) private msalInstance: any, private broadcastService: MsalBroadcastService, private authService: MsalService) {
    this.dtV = dt;
    this.authService.initialize();
    ApiConfigService.prototype.apiBasedonEnv(); //get the api endpoints based on environments
    /******** Primary Model *******************/
    this.primaryNavModel = {
      id: 'PrimaryNavigation',
      links: []
    };
    /******** Primary Model *******************/
    /******** Global Nav Model ****************/
    this.globalNavModel = {
      id: 'GlobalNavigation',
      useStripOnMobile: true,
      links: [
        {
          id: 'help',
          textTemplate: 'Help',
          enableIcon: true,
          iconType: 'help_hollow',
          dropDown: {
            id: 'helpdropdown',
            links: [
              {
                id: 'contactus',
                textTemplate: 'Contact Us',
                emitEvent: true
              }
            ]
          }
        }
      ]
    };
    this.apiEndPoint = ApiConfigService.prototype.API_ENDPOINT;
    this.primaryNavModel = {
      id: 'PrimaryNavigation',
      links: [
        {
          id: 'home',
          textTemplate: 'Home',
          url: '/home',
          enableIcon: true,
          iconType: 'home',
          selected: true
        },
        {
          id: 'jobsandrules',
          textTemplate: 'Jobs and Rules',
          dropDown: {
            links: [
              {
                id: 'JobManagement',
                textTemplate: 'Job Management',
                url: '/admin/jobManagement',
                disabled: false
              },
              {
                id: 'DQRuleManagement',
                textTemplate: 'Rule Management',
                url: '/ruleCreation',
                disabled: false
              },
              {
                id: 'DQRuleAssignment',
                textTemplate: 'Rule Association',
                url: '/ruleAssignment',
                disabled: false
              },
              {
                id: 'ListManagement',
                textTemplate: 'List Management',
                url: '/admin/listManagement',
                disabled: false
              }
            ]
          }
        },
        {
          id: 'profiling',
          textTemplate: 'Profiling',
          dropDown: {
            links: [
              {
                id: 'ProfilingJobManagement',
                textTemplate: 'Job Management',
                url: '/profiling/jobManagement',
                disabled: false
              },

              {
                id: 'ProfilingHistoryManagement',
                textTemplate: 'Job History',
                url: '/profiling/jobHistory',
                disabled: false
              },
              {
                id: 'ProfilingResultManagement',
                textTemplate: 'Profiled Entity Results',
                url: '/profiling/jobResults',
                disabled: false
              }
            ]
          },
          emitEvent: true
        },
        {
          id: 'admin',
          textTemplate: 'Administration',
          dropDown: {
            links: [
              {
                id: 'TenantManagement',
                textTemplate: 'Tenant Management',
                url: '/admin/tenantManagement',
                disabled: false
              },

              {
                id: 'UserManagement',
                textTemplate: 'User Management',
                url: '/admin/userManagement',
                disabled: false
              },
              {
                id: 'FunctionManagement',
                textTemplate: 'Function Management',
                url: '/admin/functionManagement',
                disabled: false
              },
              {
                id: 'RoleManagement',
                textTemplate: 'Role Management',
                url: '/admin/roleManagement',
                disabled: false
              },
              {
                id: 'DBConnectionManagement',
                textTemplate: 'DB Connection Management',
                url: '/admin/dbManagement',
                disabled: false
              },
              {
                id: 'DBAccessManagement',
                textTemplate: 'DB Access Management',
                url: '/admin/dbAccessManagement',
                disabled: false
              }
            ]
          },
          emitEvent: true
        },
        {
          id: 'DQEdashboard',
          textTemplate: 'Dashboard',
          dropDown: {
            links: [
              {
                id: 'dimensionScorecard',
                textTemplate: 'Dimension Scorecard',
                enableIcon: true,
                iconType: 'new-window',
                emitEvent: true,
                disabled: false
              },
              {
                id: 'entityScore',
                textTemplate: 'Entity Dimension Score',
                enableIcon: true,
                iconType: 'new-window',
                emitEvent: true,
                disabled: false
              },
              // {
              //   id: 'entitySummary',
              //   textTemplate: 'Entity Summary',
              //   enableIcon: true,
              //   iconType: 'new-window',
              //   emitEvent: true,
              //   disabled: false
              // },
              {
                id: 'entityVolume',
                textTemplate: 'Volumetric Analysis',
                enableIcon: true,
                iconType: 'new-window',
                emitEvent: true,
                disabled: false
              },
              {
                id: 'jobHistory',
                textTemplate: 'Job History',
                enableIcon: true,
                iconType: 'new-window',
                emitEvent: true,
                disabled: false
              },
              {
                id: 'checkResults',
                textTemplate: 'Check Results',
                enableIcon: true,
                iconType: 'new-window',
                emitEvent: true,
                disabled: false
              }
            ]
          },
          emitEvent: true
        }
      ]
    };

    cm.changeEmitted$.subscribe((data) => {
      //This subscriber is executed when tenant is selected on the popup and at the top navigation.
      if (data && data[1] && data[1].clients) {
        sessionStorage.setItem('clients', JSON.stringify(data[1].clients));
      }
      this.loadGlobalNavModel();
      if (data[0] && data[0].clientData == '') {
        this.dtV.userName = '';
        this.dtV.clientData = undefined;
        this.globalNavModel = {
          id: 'GlobalNavigation',
          useStripOnMobile: true,
          links: [
            {
              id: 'helpdd',
              textTemplate: 'Help',
              enableIcon: true,
              iconType: 'help',
              dropDown: {
                id: 'helpdropdown',
                links: [
                  {
                    id: 'help',
                    textTemplate: 'User Guide',
                    emitEvent: true
                  },
                  {
                    id: 'contactus',
                    textTemplate: '<span>Contact Us</help>',
                    emitEvent: true
                  }
                ]
              }
            }
          ]
        };
        return;
      }
      this.dtV.clientData = JSON.parse(sessionStorage.getItem('clientData'));
      this.primaryNavModel = {
        id: 'PrimaryNavigation',
        links: [
          {
            id: 'home',
            textTemplate: 'Home',
            url: '/home',
            enableIcon: true,
            iconType: 'home',
            selected: true
          },
          {
            id: 'jobsandrules',
            textTemplate: 'Jobs and Rules',
            dropDown: {
              links: [
                {
                  id: 'JobManagement',
                  textTemplate: 'Job Management',
                  url: '/admin/jobManagement',
                  disabled: false
                },
                {
                  id: 'DQRuleManagement',
                  textTemplate: 'Rule Management',
                  url: '/ruleCreation',
                  disabled: false
                },
                {
                  id: 'DQRuleAssignment',
                  textTemplate: 'Rule Association',
                  url: '/ruleAssignment',
                  disabled: false
                },
                {
                  id: 'ListManagement',
                  textTemplate: 'List Management',
                  url: '/admin/listManagement',
                  disabled: false
                }
              ]
            }
          },
          {
            id: 'profiling',
            textTemplate: 'Profiling',
            dropDown: {
              links: [
                {
                  id: 'ProfilingJobManagement',
                  textTemplate: 'Job Management',
                  url: '/profiling/jobManagement',
                  disabled: false
                },
  
                {
                  id: 'ProfilingHistoryManagement',
                  textTemplate: 'Job History',
                  url: '/profiling/jobHistory',
                  disabled: false
                },
                {
                  id: 'ProfilingResultManagement',
                  textTemplate: 'Profiled Entity Results',
                  url: '/profiling/jobResults',
                  disabled: false
                }
              ]
            },
            emitEvent: true
          },
          {
            id: 'admin',
            textTemplate: 'Administration',
            dropDown: {
              links: [
                {
                  id: 'TenantManagement',
                  textTemplate: 'Tenant Management',
                  url: '/admin/tenantManagement',
                  disabled: false
                },
                {
                  id: 'UserManagement',
                  textTemplate: 'User Management',
                  url: '/admin/userManagement',
                  disabled: false
                },
                {
                  id: 'FunctionManagement',
                  textTemplate: 'Function Management',
                  url: '/admin/functionManagement',
                  disabled: false
                },
                {
                  id: 'RoleManagement',
                  textTemplate: 'Role Management',
                  url: '/admin/roleManagement',
                  disabled: false
                },
                {
                  id: 'DBConnectionManagement',
                  textTemplate: 'DB Connection Management',
                  url: '/admin/dbManagement',
                  disabled: false
                },
                {
                  id: 'DBAccessManagement',
                  textTemplate: 'DB Access Management',
                  url: '/admin/dbAccessManagement',
                  disabled: false
                }
              ]
            },
            emitEvent: true
          },
          {
            id: 'DQEdashboard',
            textTemplate: 'Dashboard',
            dropDown: {
              links: [
                {
                  id: 'dimensionScorecard',
                  textTemplate: 'Dimension Scorecard',
                  enableIcon: true,
                  iconType: 'new-window',
                  emitEvent: true,
                  disabled: false
                },
                {
                  id: 'entityScore',
                  textTemplate: 'Entity Dimension Score',
                  enableIcon: true,
                  iconType: 'new-window',
                  emitEvent: true,
                  disabled: false
                },
                {
                  id: 'entityVolume',
                  textTemplate: 'Volumetric Analysis',
                  enableIcon: true,
                  iconType: 'new-window',
                  emitEvent: true,
                  disabled: false
                },
                {
                  id: 'jobHistory',
                  textTemplate: 'Job History',
                  enableIcon: true,
                  iconType: 'new-window',
                  emitEvent: true,
                  disabled: false
                },
                {
                  id: 'checkResults',
                  textTemplate: 'Check Results',
                  enableIcon: true,
                  iconType: 'new-window',
                  emitEvent: true,
                  disabled: false
                }
              ]
            },
            emitEvent: true
          }
        ]
      };
      if (data.tenantId) {
        this.primaryNavModel.links[1].dropDown.links[1].url = '/ruleCreation/' + data.tenantId;
      } else {
        if (!data.userinfo) {
          this.clientsArr = [];
          if (data[1].clients.length > 1) {
            for (let i = 0; i < data[1].clients.length; i++) {
              this.clientsArr[i] = {
                id: data[1].clients[i].tenantId,
                textTemplate: data[1].clients[i].tenantNm,
                emitEvent: true
              };
            }
            this.globalNavModel.links[2] = {
              id: 'selectedClient',
              textTemplate: 'Tenant: ' + data[0].clientData.tenantNm,
              dropDown: {
                id: 'GlobalNavigation_Welcome_Press2',
                links: this.clientsArr
              }
            };
          } else {
            this.globalNavModel.links[2] = {
              id: 'selectedClient',
              textTemplate: 'Tenant: ' + data[0].clientData.tenantNm
            };
          }
          if (!sessionStorage.getItem('clientData')) {
            sessionStorage.setItem('clientData', JSON.stringify(data[0].clientData));
          }
          this.primaryNavModel.links[1].dropDown.links[1].url = '/ruleCreation/' + data[0].clientData.tenantId;
        } else {
          this.globalNavModel = {
            id: 'GlobalNavigation',
            useStripOnMobile: true,
            links: [
              {
                id: 'userName',
                textTemplate: 'Welcome, ' + data.userinfo.userFirstNm + '!',
                enableIcon: false
              },
              {
                id: 'envName',
                textTemplate: 'Env: ' + (this.isProd == 'dev' ? 'Test' : this.isProd == 'stage' ? 'Stage' : 'Prod'),
                enableIcon: false
              },
              {
                id: 'tenantName',
                textTemplate: '',
                enableIcon: false,
                emitEvent: true,
                iconType: '',
                dropDown: {
                  id: 'tenant',
                  links: this.clientsArr
                }
              },
              {
                id: 'helpdd',
                textTemplate: 'Help',
                enableIcon: true,
                iconType: 'help',
                dropDown: {
                  id: 'helpdropdown',
                  links: [
                    {
                      id: 'help',
                      textTemplate: 'User Guide',
                      emitEvent: true
                    },
                    {
                      id: 'contactus',
                      textTemplate: 'Contact Us',
                      emitEvent: true
                    }
                  ]
                }
              },
              {
                id: 'signout',
                textTemplate: 'Sign Out',
                url: '/',
                emitEvent: true
              }
            ]
          };
        }
      }
      //After tenant change, fire roles call with latest tenant id
      let varTenId;
      if (Array.isArray(data)) {
        varTenId = data[0].clientData.tenantId;
      } else if (data.tenantId) {
        varTenId = data.tenantId;
      } else {
        return;
      }
      let cookieinfo = localStorage.getItem('userInfo');
      if (cookieinfo != '') {
        this.username = JSON.parse(cookieinfo).userFirstNm;
        this.getRoleBasedData(varTenId, JSON.parse(cookieinfo).userId, true);
      }
    });
  }
  async ngOnInit() {
    await this.initializeMsal();
    const response = await this.authService.instance.handleRedirectPromise();
    if (response?.account) {
      this.authService.instance.setActiveAccount(response.account);
      localStorage.setItem('accountid', response.account.username);
    }
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });
    
    this.username = this.dt.userName;
    // Subscribe to the inProgress$ observable to check for InteractionStatus.None
    this.broadcastService.inProgress$.pipe(filter((status: InteractionStatus) => status === InteractionStatus.None)).subscribe(() => {
      this.handleLoginFlow();
    });

    this.broadcastService.msalSubject$.pipe(filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS)).subscribe((result: EventMessage) => {
      localStorage.setItem('accountid', result.payload['account']['username']);
      let getTenantsURL = this.apiEndPoint + 'dq-tenants/user/' + result['payload']['account']['username'];
      this.loadTenantData(getTenantsURL, result);
    });
    //"code" param : When we login the it returns the code using which we can get out=r different tokens
    //"account id" : When the user logins then in local storage we stored the email id of the user
    // 1st Condition : When in url "code" is not present and also the account id is not stored in local storage then we will call login function
    if (window.location.href.indexOf('code') == -1 && !localStorage.getItem('accountid')) {
      this.login();
    }
    else {
      //If the user is logged in and account id is present
      let __this = this;
      if (localStorage.getItem('accountid')) {
        let userid = localStorage.getItem('accountid');
        let getTenantsURL = __this.apiEndPoint + 'dq-tenants/user/' + userid;
        __this.http.get(getTenantsURL).subscribe(
          (data) => {
            let tokenString = localStorage.getItem('resToken');
            let tokenGroup = jwt_decode(tokenString);
            if (tokenGroup.groups == undefined && tokenGroup._claim_sources) {
              sessionStorage.setItem('groupTooLarge', 'true');
              if (data.length == 0) {
                this.router.navigate(['/authError']);
                this.notAuthorized = true;
                return;
              }
            } else if (tokenGroup && tokenGroup.groups) {
              if (!tokenGroup.groups.includes(environment.ssogroupname)) {
                this.router.navigate(['/authError']);
                return;
              }
            }
            sessionStorage.setItem('clients', JSON.stringify(data));
            if (!sessionStorage.getItem('clientData')) {
              sessionStorage.setItem('clientData', JSON.stringify(data[0]));
            }
            if (data.length == 0) {
              this.jermessageModal.visible = true;
              this.jermessageModal.content = 'There are no tenants assosciated with this user';
              return;
            }
            let userinfo = {
              userId: localStorage.getItem('accountid'),
              userFirstNm: tokenGroup.name.split(',')[1],
              userLastNm: tokenGroup.name.split(',')[0],
              userEmailAddress: tokenGroup.preferred_username
            };
            localStorage.setItem('userInfo', JSON.stringify(userinfo))
            if (data.length == 1 && sessionStorage.getItem('clientData')) {
              this.getRoleBasedData(JSON.parse(sessionStorage.getItem('clientData')).tenantId, userid);
            }
            if (window.location.href.split('.com/')[1] && window.location.href.split('.com/')[1] != 'selectTenant') {
              __this.loadGlobalNavModel();
            }
            let browserURLContent = window.location.href.split('/')[3];
            if ((window.location.href.split('.com/')[1] && window.location.href.split('.com/')[1].indexOf('code') != -1 && window.location.href.split('.com/')[1] != 'selectTenant') || !browserURLContent || browserURLContent == '') {
              __this.navigateOnClientData(userid);
            }
          },
          (err) => {
            this.jermessageModal.visible = true;
            this.jermessageModal.content = err;
          }
        );
      }
    }
    let selectedJob;
    if (sessionStorage.getItem('selectedJob') && Object.keys(JSON.parse(sessionStorage.getItem('selectedJob'))).length) {
      selectedJob = JSON.parse(sessionStorage.getItem('selectedJob'));
    }
    this.dt.setData('selectedJob', selectedJob);
    if (window.location.pathname.indexOf('ruleAssignment') >= 0 && !selectedJob) {
      this.router.navigate(['/ruleAssignment']);
    } else if (window.location.pathname.indexOf('login') >= 0) {
      sessionStorage.setItem('clientData', JSON.stringify({}));
    }
    if (sessionStorage.getItem('clientData') && localStorage.getItem('userInfo')) {
      this.getRoleBasedData(JSON.parse(sessionStorage.getItem('clientData')).tenantId, JSON.parse(localStorage.getItem('userInfo')).userId);
    }
  }
  loadGlobalNavModel() {
    if (localStorage.getItem('userInfo') != '') {
      let userinfo = JSON.parse(localStorage.getItem('userInfo'));
      this.dtV.userName = userinfo;
      let data = JSON.parse(sessionStorage.getItem('clients'));
      if (sessionStorage.getItem('clientData') != 'undefined' && Object.keys(JSON.parse(sessionStorage.getItem('clientData'))).length != 0 && data.length != 0) {
        this.dtV.clientData = JSON.parse(sessionStorage.getItem('clientData'));
        this.globalNavModel = {
          id: 'GlobalNavigation',
          useStripOnMobile: true,
          links: [
            {
              id: 'userName',
              textTemplate: 'Welcome, ' + this.dtV.userName.userFirstNm + '!',
              enableIcon: true,
              iconType: 'person'
            },
            {
              id: 'envName',
              textTemplate: 'Env: ' + (this.isProd == 'dev' ? 'Test' : this.isProd == 'stage' ? 'Stage' : 'Prod'),
              enableIcon: false
            },

            {
              id: 'selectedClient',
              textTemplate: 'Tenant: ' + this.dtV.clientData.tenantNm,
              dropDown: {
                id: 'tenant',
                links: this.clientsArr
              }
            },
            {
              id: 'helpdd',
              textTemplate: 'Help',
              enableIcon: true,
              iconType: 'help',
              dropDown: {
                id: 'helpdropdown',
                links: [
                  {
                    id: 'help',
                    textTemplate: 'User Guide',
                    emitEvent: true
                  },
                  {
                    id: 'contactus',
                    textTemplate: 'Contact Us',
                    emitEvent: true
                  }
                ]
              }
            },
            {
              id: 'signout',
              textTemplate: 'Sign Out',
              url: '/',
              emitEvent: true
            }
          ]
        };
        this.clientsArr = [];
        if (data.length > 1) {
          for (let i = 0; i < data.length; i++) {
            this.clientsArr[i] = {
              id: data[i].tenantId,
              textTemplate: data[i].tenantNm,
              emitEvent: true
            };
          }
          this.globalNavModel.links[2] = {
            id: 'selectedClient',
            textTemplate: 'Tenant: ' + this.dtV.clientData.tenantNm,
            dropDown: {
              id: 'GlobalNavigation_Welcome_Press2',
              links: this.clientsArr
            }
          };
        } else {
          this.globalNavModel.links[2] = {
            id: 'selectedClient',
            textTemplate: 'Tenant: ' + this.dtV.clientData.tenantNm
          };
        }
        this.primaryNavModel.links[1].dropDown.links[1].url = '/ruleCreation/' + this.dtV.clientData.tenantId;
      } else {
        this.globalNavModel = {
          id: 'GlobalNavigation',
          useStripOnMobile: true,
          links: [
            {
              id: 'helpdd',
              textTemplate: 'Help',
              enableIcon: true,
              iconType: 'help',
              dropDown: {
                id: 'helpdropdown',
                links: [
                  {
                    id: 'help',
                    textTemplate: 'User Guide',
                    emitEvent: true
                  },
                  {
                    id: 'contactus',
                    textTemplate: 'Contact Us',
                    emitEvent: true
                  }
                ]
              }
            }
          ]
        };
      }
    } else {
      this.globalNavModel = {
        id: 'GlobalNavigation',
        useStripOnMobile: true,
        links: [
          {
            id: 'helpdd',
            textTemplate: 'Help',
            enableIcon: true,
            iconType: 'help',
            dropDown: {
              id: 'helpdropdown',
              links: [
                {
                  id: 'help',
                  textTemplate: 'User Guide',
                  emitEvent: true
                },
                {
                  id: 'contactus',
                  textTemplate: 'Contact Us',
                  emitEvent: true
                }
              ]
            }
          }
        ]
      };
    }
  }
  ngAfterViewInit() {
    let __this = this;
    setTimeout(function () {
      __this.cdr.detectChanges();
    }, 100);
  }
  navigateOnClientData(userid) {
    let getTenantsURL = this.apiEndPoint + 'dq-tenants/user/' + userid;
    this.http.get(getTenantsURL).subscribe(
      (data) => {
        if (data.length == 0) {
          this.jermessageModal.visible = true;
          this.jermessageModal.content = 'There are no tenants assosciated with this user';
          return;
        }
        this.navigateToHome(data);
      },
      (err) => {
        this.jermessageModal.visible = true;
        this.jermessageModal.content = err;
      }
    );
  }
  navigateOnClientDataFromProfiling(userid, tenantId) {
    let getTenantsURL = this.apiEndPoint + 'dq-tenants/user/' + userid;
    this.http.get(getTenantsURL).subscribe(
      (data) => {
        let dataTenant;
        let allData = data;
        for (let i = 0; i < data.length; i++) {
          if (data[i].tenantId == tenantId) {
            dataTenant = data[i];
          }
        }
        this.getRoleBasedData(tenantId, userid);
        this.navigateToHomeFromProfiling(dataTenant, allData);
      },
      (err) => {
        this.jermessageModal.visible = true;
        this.jermessageModal.content = err;
      }
    );
  }
  handleLoginFlow() {
    if (window.location.href.indexOf('code') == -1 && !localStorage.getItem('accountid')) {
      this.login();
    }
  }
  navigateToHomeFromProfiling(tenantids, data) {
    if (data.length > 1) {
      data = this.cu.sortObjectForDropdown(data, 'tenantNm');
      sessionStorage.setItem('clientData', JSON.stringify(tenantids));
      sessionStorage.setItem('clients', JSON.stringify(data));
      this.cm.emitChange([{ clientData: tenantids }, { clients: data }]);
      this.router.navigate(['/home']);
    } else {
      sessionStorage.setItem('clientData', JSON.stringify(data));
      this.cm.emitChange([{ clientData: data[0] }, { clients: data[0] }]);
      this.router.navigate(['/home']);
    }
  }

  navigateToHome(data) {
    if (data.length > 1) {
      data = this.cu.sortObjectForDropdown(data, 'tenantNm');
      sessionStorage.setItem('clientData', JSON.stringify(data));
      sessionStorage.setItem('clients', JSON.stringify(data));
      this.router.navigate(['/selectTenant']);
    } else {
      sessionStorage.setItem('clientData', JSON.stringify(data[0]));
      this.router.navigate(['/home']);
      this.loadGlobalNavModel();
    }
  }
  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
  loadTenantData(getTenantsURL, result) {
    this.http.get(getTenantsURL).subscribe(
      (data) => {
        sessionStorage.setItem('clients', JSON.stringify(data));
        if (!sessionStorage.getItem('clientData')) {
          sessionStorage.setItem('clientData', JSON.stringify(data[0]));
        }
        this.retreiveUserDetails(result.payload.idToken);
      },
      (err) => {
        if (this.countApi <= 3) {
          this.countApi++;
          this.loadTenantData(getTenantsURL, result);
        }
      }
    );
  }
  // in this method will decode the token string and get user's info and check the validation
  retreiveUserDetails(tokenString) {
    let tokenDetail = jwt_decode(tokenString);
    let userinfo = {
      userId: localStorage.getItem('accountid'),
      userFirstNm: tokenDetail.name.split(',')[1],
      userLastNm: tokenDetail.name.split(',')[0],
      userEmailAddress: tokenDetail.preferred_username
    };
    localStorage.setItem('userInfo', JSON.stringify(userinfo));
    //if the token does not include groups and includs _claim_sources it means the user has access to more no of groups so will check if they are added to any tenant or not
    if (tokenDetail.groups == undefined && tokenDetail._claim_sources) {
      sessionStorage.setItem('groupTooLarge', 'true');
      if (sessionStorage.getItem('clientData') && sessionStorage.getItem('clientData') == 'undefined') {
        this.router.navigate(['/authError']);
        this.notAuthorized = true;
        return;
      }
    } else if (tokenDetail && tokenDetail.groups) {
      this.username = userinfo.userFirstNm;
      if (!tokenDetail.groups.includes(environment.ssogroupname)) {
        this.router.navigate(['/authError']);
        this.notAuthorized = true;
        return;
      }
    }
    if (sessionStorage.getItem('clientData') && sessionStorage.getItem('clientData') == 'undefined') {
      this.jermessageModal.visible = true;
      this.jermessageModal.content = 'There are no tenants assosciated with this user';
      return;
    }
    this.notAuthorized = false;
    this.getRoleBasedData(JSON.parse(sessionStorage.getItem('clientData')).tenantId, userinfo.userId);
    this.onLogin.emit(userinfo);
    if (sessionStorage.getItem('tenant')) {
      let tenantIds = JSON.parse(sessionStorage.getItem('tenant')).tenantId;
      this.navigateOnClientDataFromProfiling(tokenDetail.userId, tenantIds);
      sessionStorage.setItem('tenant', '');
    } else {
      this.navigateOnClientData(userinfo.userId);
    }
  }
  navigateToJobManagement() {}
  getRoleBasedData(tenantId, userid, tenantChange?) {
    let getRolesComponentsURL = this.apiEndPoint + 'dq-users/user/' + userid + '/tenant/' + tenantId;
    this.http.get(getRolesComponentsURL).subscribe(
      (roleComponents) => {
        let userRoles = [];
        let functionList = [];
        for (var i = 0; i < roleComponents.roleList.length; i++) {
          userRoles.push(roleComponents.roleList[i].roleNm);
          let roleName = roleComponents.roleList[i].roleNm;
          for (var j = 0; j < roleComponents.roleList[i].functionList.length; j++) {
            functionList.push(roleComponents.roleList[i].functionList[j].functionNm);
            let functionNm = roleComponents.roleList[i].functionList[j].functionNm;
            functionNm = functionNm.replace(/ /g, '');
            roleName = roleName.replace(/ /g, '');
            if (this.dt.getData(functionNm) && !tenantChange) {
              let newObj = this.handleMultipleRoles(this.dt.getData(functionNm), roleComponents.roleList[i].functionList[j].dqRoleFunctionComponentList);
              this.dt.setData(functionNm,newObj);
            } else {
              this.dt.setData(functionNm, roleComponents.roleList[i].functionList[j].dqRoleFunctionComponentList);
            }
          }
        }
        this.dt.setData('rolesList', userRoles);
        this.dt.setData('functionList', functionList);
        this.filterGlobalNavMenus(functionList);
        this.cm.emitRolesReady({});
      },
      (err) => {}
    );
  }
  handleMultipleRoles(existingCompList, newCompList) {
    let newObj = {};
    this.cu.sortObjectForDropdown(existingCompList, 'componentNm');
    this.cu.sortObjectForDropdown(newCompList, 'componentNm');
    for (var i = 0; i < existingCompList.length; i++) {
      if (existingCompList[i].componentActiveFlag == 'Y' || newCompList[i].componentActiveFlag == 'Y') {
        newCompList[i].componentActiveFlag = 'Y';
      } else {
        newCompList[i].componentActiveFlag = 'N';
      }
    }
    return newCompList;
  }
  isActive(url) {
    return this.router.url === url;
  }
  isDropdownActive(dropdownLinks: any[]): boolean {
    return dropdownLinks.some((link) => this.isActive(link.url));
  }
  filterGlobalNavMenus(functionList) {
    let filteredModel = {};
    let arrFunc = [];
    for (var i = 0; i < functionList.length; i++) {
      arrFunc[i] = functionList[i].replace(/ /g, '');
    }
    for (var j = 0; j < this.primaryNavModel.links[1].dropDown.links.length; j++) {
      if (!arrFunc.includes(this.primaryNavModel.links[1].dropDown.links[j].id)) {
        this.primaryNavModel.links[1].dropDown.links[j].disabled = true;
      }
    }
    for (var j = 0; j < this.primaryNavModel.links[3].dropDown.links.length; j++) {
      if (!arrFunc.includes(this.primaryNavModel.links[3].dropDown.links[j].id)) {
        this.primaryNavModel.links[3].dropDown.links[j].disabled = true;
      }
    }
    for (var j = 0; j < this.primaryNavModel.links[2].dropDown.links.length; j++) {
      if (!arrFunc.includes(this.primaryNavModel.links[2].dropDown.links[j].id)) {
        this.primaryNavModel.links[2].dropDown.links[j].disabled = true;
      }
    }
    for (var j = 0; j < this.primaryNavModel.links[4].dropDown.links.length; j++) {
      if (!arrFunc.includes(this.primaryNavModel.links[4].dropDown.links[j].id)) {
        this.primaryNavModel.links[4].dropDown.links[j].disabled = true;
      }
    }
  }
  handleOnNavClick(e) {
    if (e.id == 'signout') {
      this.logout();
    } else if (e.id == 'help') {
      this.getHelpFile();
    } else if (e.id == 'contactus') {
      this.showContactDialog = true;
    } else if (e.id == 'userName') {
    } else {
      this.globalNavModel.links[2].textTemplate = e.textTemplate;
      let tenantNm = e.textTemplate;
      sessionStorage.setItem('clientData', JSON.stringify({ tenantId: e.id, tenantNm: tenantNm }));
      this.cm.emitChange({ tenantId: e.id, tenantNm: tenantNm });
    }
  }
  handlePrimaryClick(e) {
    let clientData = JSON.parse(sessionStorage.getItem('clientData'));
    if (clientData) {
      this.currentTenantId = clientData.tenantId;
    }
    if (e.url && e.id == 'DQRuleManagement') {
      let url = e.url;
      const pattern = /\/ruleCreation\/[a-zA-Z0-9]+$/;
      if (!pattern.test(url)) {
        url += `/${this.currentTenantId}`;
      }
      this.router.navigate([url]);
    } else if (e.id == 'dimensionScorecard' || e.id == 'checkResults' || e.id == 'entityVolume' || e.id == 'jobHistory' || e.id == 'entityScore') {
      clientData = JSON.parse(sessionStorage.getItem('clientData'));
      if (this.isProd == 'prod') {
        window.open('https://dqaas.optum.com/dqaas-dashboard/tenantNm?' + clientData.tenantNm + '&page=' + e.id, '_blank');
      } else if (this.isProd == 'stage') {
        window.open('https://dqaas-stg.optum.com/dqaas-dashboard/tenantNm?' + clientData.tenantNm + '&page=' + e.id, '_blank');
      } else {
        window.open('https://dev-dqaas-services.optum.com/dqaas-dashboard/tenantNm?' + clientData.tenantNm + '&page=' + e.id, '_blank');
      }
    }
  }
  openServiceNowLink() {
    window.open('https://optum.service-now.com/nav_to.do?uri=%2Fincident.do%3Fsys_id%3D-1%26sysparm_query%3Dactive%3Dtrue%26sysparm_stack%3Dincident_list.do%3Fsysparm_query%3Dactive%3Dtrue');
  }
  openHubConnectLink() {
    window.open('https://hubconnect.uhg.com/docs/DOC-247283');
  }
  getHelpFile() {
    window.open('https://docs.hcp.uhg.com/dqaas');
  }
  logout() {
    // Add log out function here
    this.authService.logoutRedirect({
      postLogoutRedirectUri: ''
    });
  }
  login() {
    if (this.msalGuardConfig.authRequest) {
      this.authService.loginRedirect({
        ...this.msalGuardConfig.authRequest
      } as RedirectRequest);
    } else {
      this.authService.loginRedirect();
    }
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
  handletenantClick(e) {}
  handleButtonClick(e) {
    this.jermessageModal.visible = false;
    this.infoMessage.isInfoNotificationVisible = false;
  }
}
